// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__28YZr","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1TQM3"};